import useFreePlanStatus from '../../hooks/useFreePlanStatus';
import ExpiredPlanModal from '../ExpiredPlanModal';

/**
 * Guard de Rota - Protege rotas bloqueando acesso para usuários com plano FREE expirado
 * Exibe modal de bloqueio quando o plano está expirado
 */
export default function FreeExpiredGuard({ children }) {
  const freeStatus = useFreePlanStatus();
  
  // Se o plano FREE está expirado, exibe o modal de bloqueio
  if (freeStatus.isExpired) {
    return <ExpiredPlanModal />;
  }
  
  // Caso contrário, renderiza o conteúdo normalmente
  return <>{children}</>;
}
